<template>
<div class="chapter">
<div class="inner_page">
<p class="default" id="d8e75NaN">
</p><p class="crth" id="d7e292">Nightmare in Niceville <br/>© 2011 Amberle Cianne. All Rights Reserved.</p>
<p class="crt" id="d7e402">No part of this book may be reproduced in any form or by any means, electronic, mechanical, digital, photocopying, or recording, except for the inclusion in a review, without permission in writing from the publisher.</p>
<p class="crt" id="d7e522">First edition.</p>
<p class="crt" id="d7e572">This is a work of fiction. All of the characters, names, incidents, organizations, and dialogue in this novel are either the products of the author’s imagination or are used fictitiously.</p>
<p class="crt" id="d7e692">Published in the U.S. by BQB Publishing Company<br/><a href="http://www.bqbpublishing.com" id="d14e67" target="_blank">www.bqbpublishing.com</a></p>
<p class="crt" id="d14e69">Printed in the United States of America </p>
<p class="crt" id="d14e71">ISBN 978-0-9831699-4-9 (p)<br/>ISBN 978-1-937084-42-4 (e) </p>
<p class="crt" id="d14e75">Library of Congress Control Number: 2011940348</p>
<p class="crt" id="d14e77">Cover painting by Michael Mustachio<br/>Book interior by Robin Krauss, Linden Design, <a href="http://www.lindendesign.biz" id="d14e81" target="_blank">www.lindendesign.biz</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Cian_9781937084424_epub_c4_r1.vue?07c2cad0